import React, { useState } from 'react';
import { Button, useDataProvider, useRedirect, useNotify } from "react-admin";
import TextField from "@mui/material/TextField";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import FormGroup from "@mui/material/FormGroup";



import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { useFileUpload } from 'use-file-upload';
import { uploadFile } from "../helpers/fileUpload";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import LetterIcon from '@mui/icons-material/ReceiptOutlined';
import AuthenticatedFileLink from "../uiComponents/AuthenticatedFileLink";
const DiscontinueSponsorship = ({record}) => {
    const notify = useNotify();
    const dataProvider = useDataProvider();
    const [reason,setReason] = useState('')
    const [uploading,setUploading] = useState(false)
    const [date,setDate] = useState(new Date().toString())
    const [remark,setRemark] = useState('')
    const [leaveLetter,setLeaveLetter] = useState('')
    const [dialogOpen, setDialogOpen] = useState(false);
    // Only the setter is used: the selected file arrives through selectFile's
    // callback, so the hook's own `file` value was never read.
    const [, selectFile] = useFileUpload()
    const handleClickOpen = () => {
        //showNotification('Sorry, we couldn\'t upload the file, tye again later','error')
        setDialogOpen(true);
    };

    const handleClose = () => {
        setDialogOpen(false);
    };
    const redirect = useRedirect();
    const reasons = ['Home Visit Result', 'Sponsor Requested','Beneficiary Requested'];
    const onFileUpload = () => {

        selectFile({ accept: '*.*' }, ({ source, name, size, file }) => {
            // file - is the raw File Object
            //console.log({ source, name, size, file })
            // Todo: Upload to cloud.
            setUploading(true)
            uploadFile(file,'documents',record.registrationId+'-LeaveLetter' ).then(res=>{
                const data = res.data
                if(data) {
                    setLeaveLetter(data.secure_url)
                }
                setUploading(false)
              //  console.log(res)
             }).catch(e=>{
                 notify('Sorry, we couldn\'t upload the file, tye again later','error')
             })
        })
    }
        const handleConfirm = () => {

        const exitInfo = {reason, remark, leaveLetter, date}
        dataProvider.update('Record',{data:{exitInfo, status:'Discontinued',id:record.id}}).then(()=>{
            setDialogOpen(false)
            redirect('/Record')
        })
    };
    return (
        <div>
            <Button variant="contained" onClick={handleClickOpen} label="Discontinue Sponsorship" />
            <Dialog  fullWidth maxWidth="md" open={dialogOpen} onClose={handleClose}  aria-labelledby="form-dialog-title">

                <DialogTitle id="form-dialog-title">Discontinue {record.name}'s Sponsorship</DialogTitle>
                <DialogContent>
                    <div>
                        <FormGroup>
                            <DatePicker
                            label="Date Discontinued"
                            value={date ? new Date(date) : null}
                            onChange={(newValue) => setDate(newValue ? newValue.toString() : '')}
                            slotProps={{ textField: { margin: 'normal' } }}
                        />
                        <FormControl  margin='normal'>
                            <InputLabel id="demo-simple-select-label">Reason</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={reason}
                                onChange={ev=>setReason(ev.target.value)}
                            >
                                {reasons.map(r=>  <MenuItem value={r}>{r}</MenuItem>)}

                            </Select>
                        </FormControl>
                        <TextField
                            value={remark}
                            onChange={ev=>setRemark(ev.target.value)}
                            label="Remark"
                            multiline
                            rows={3}
                            rowsMax={5}
                            margin='normal'
                        />

                        </FormGroup>
                        </div>


                </DialogContent>
                <Grid container>
                    <Grid item>
                        <Button color="primary"
                                disabled={uploading}
                                onClick={onFileUpload}
                                label={"Upload the leave letter"}
                                startIcon={<LetterIcon/>}
                        >

                            {uploading&& <CircularProgress size={24} />}
                        </Button>
                    </Grid>
                    <Grid item>
                        {leaveLetter&&<div>
                            <LetterIcon/> <AuthenticatedFileLink path={leaveLetter}/>
                        </div>}
                    </Grid>
                </Grid>



                <DialogActions>
                    <Button disabled={uploading} onClick={handleConfirm} label="Confirm"/>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default DiscontinueSponsorship;
